import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api, ApiClientError } from '../api';
import { useAuth } from '../auth';

export function ReferralLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!slug || loading) return;
    void api<{ creator: { slug: string; display_name: string }; self_referral?: boolean }>(
      `/affiliates/claim/${encodeURIComponent(slug)}`,
    )
      .then((result) => {
        if (user) {
          if (result.self_referral) {
            navigate('/pricing?ref_notice=self_referral', { replace: true });
          } else {
            navigate('/pricing', { replace: true });
          }
        } else {
          navigate(`/signup?ref=${encodeURIComponent(result.creator.slug)}`, { replace: true });
        }
      })
      .catch((exception: unknown) => {
        setError(
          exception instanceof ApiClientError
            ? exception.message
            : 'That referral link is not valid.',
        );
      });
  }, [navigate, slug, user, loading]);

  if (error) {
    return (
      <div className="auth-card referral-miss">
        <p>Referral</p>
        <h1>This creator link is not live.</h1>
        <p>{error}</p>
        <Link className="button button--light" to={user ? '/pricing' : '/signup'}>
          {user ? 'View pricing' : 'Create an account'}
        </Link>
      </div>
    );
  }

  return (
    <div className="app-loading">
      <span />
    </div>
  );
}
